import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { QuarterSelectorOverlayComponent } from './quarter-selector-overlay/quarter-selector-overlay.component';
import { QuarterSelectorComponent } from './quarter-selector.component';
import { RangeQuarterSelectorComponent } from './range-quarter-selector.component';

@NgModule({
  imports: [CommonModule, MatInputModule, MatSelectModule, FormsModule, MatIconModule],
  exports: [QuarterSelectorComponent],
  declarations: [QuarterSelectorOverlayComponent, QuarterSelectorComponent, RangeQuarterSelectorComponent],
  providers: [],
})
export class QuarterSelectorModule {}
